import { useEffect } from "react";
import { Box, Typography, Grid, Paper, Link, capitalize } from "@mui/material";

import conf from "../conf";
import { useAuth } from "./auth/AuthProvider";
import ProtectedRoute from "./auth/ProtectedRoute";

const Home = () => {
  const auth = useAuth();
  const tiles = conf.TILES[auth.user.activeOrganization.role];

  useEffect(() => {
    document.title = "[semiauth] | home";
  }, []); // run once on mount

  return (
    <ProtectedRoute>
      <Grid container spacing={3}>
        {tiles.map((tile) => (
          <Grid item xs={12} sm={6} md={6} key={tile.key}>
            <Link
              href={tile.path}
              underline="none"
              display={tile.disabled ? "none" : "inherit"}
            >
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  transition: "0.2s",
                  justifyContent: "space-between",
                  "&:hover": {
                    boxShadow: 6,
                  },
                }}
              >
                <Box>
                  <Typography variant="h6">{capitalize(tile.key)}</Typography>
                </Box>
                <Box>{tile.icon}</Box>
              </Paper>
            </Link>
          </Grid>
        ))}
      </Grid>
    </ProtectedRoute>
  );
};

export default Home;
